<template>
    <router-link
        class="zones-list-item"
        :to="{ name: 'axRoadZoneDetails', params: { id: location.id } }"
    >
        <div class="zones-list-item__icon">
            <ZoneIcon width="16" height="16" color="#fff" />
        </div>

        <div class="l-grow-1">
            <div class="zones-list-item__heading">
                {{ location.name }}
            </div>

            <div class="zones-list-item__subheading">
                {{ $tc('trucks', trucksCount) }}
            </div>
        </div>
    </router-link>
</template>

<script>
import { mapState } from 'vuex'

import ZoneIcon from '@/components/icons/ZoneIcon'

export default {
    name: 'AxRoadTrucksListItem',
    components: {
        ZoneIcon,
    },
    props: {
        location: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapState('tracker', ['trackers']),
        trucksCount() {
            return this.trackers.filter(truck =>
                truck.asset_details.current_locations.includes(this.location.id)
            ).length
        },
    },
}
</script>

<i18n>
{
    "en": {
        "trucks": "{n} Truck | {n} Trucks"
    },
    "de": {
        "trucks": "{n} Fahrzeug | {n} Fahrzeuge"
    },
    "fr": {
        "trucks": "{n} Camion | {n} Camions"
    },
    "it": {
        "trucks": "{n} Camion | {n} Camion"
    }
}
</i18n>

<style lang="scss">
.zones-list-item {
    display: flex;
    gap: 12px;
    padding: 12px;
    border-bottom: $style-border;

    &.router-link-active {
        background-color: $color-gray-light;
        border-radius: 12px;
        border-color: transparent;
    }

    &__heading {
        font-weight: 700;
        font-size: 15px;
        line-height: 20px;
    }

    &__subheading {
        font-weight: 500;
        font-size: 15px;
        line-height: 20px;
    }

    &__icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        min-width: 40px;
        border-radius: 50%;
        background-color: $color-gray;
    }
}
</style>
